export default __webpack_public_path__ + "static/media/banner.0879a002.jpg";